import { ValidatePassword, ValidatePasswordMessage } from "@swivl-mono/helpers";
import { Button, ButtonColor, ButtonSize, PasswordInput } from "@swivl-mono/ui";
import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

import AccountModel from "../../../Models/Account/AccountModel";
import Logo from "../Assets/SwivlLogo.png";

export function ResetPasswordView() {
  const navigate = useNavigate();

  const params = useParams();

  const [password, setPassword] = useState("chuckchuck1");
  const [password2, setPassword2] = useState("chuckchuck1");
  const [errorMsg, setErrorMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const resetPassword = () => {
    setErrorMsg("");

    if (password !== password2) {
      setErrorMsg("Passwords do not match");
      return;
    }

    var isValidPassword = ValidatePassword(password);
    if (isValidPassword === false) {
      setErrorMsg(ValidatePasswordMessage);
      return;
    }
    if (!params.token) {
      setErrorMsg("Invalid token");
      return;
    }
    setIsLoading(true);

    AccountModel.resetPassword(params.token, password, navigate).catch((error) => {
      setIsLoading(false);
      setErrorMsg("Error resetting password");
    });
  };

  return (
    <div className="ForgotPasswordView flex w-[290px] flex-col items-center">
      <img src={Logo} alt="Swivl Logo" className="mx-auto mb-8 w-1/2" />
      <div className="container mx-auto">
        <div className="loginContent">
          <h1 className="mb-5 text-center text-lg">Reset Password</h1>
          <div className="mb-5 flex flex-col gap-2">
            <PasswordInput
              label="New Password"
              value={password}
              name="password"
              autoComplete="new-password"
              onChange={(e) => setPassword(e.target.value)}
            />
            <PasswordInput
              label="Repeat Password"
              value={password2}
              name="password2"
              autoComplete="new-password"
              onChange={(e) => setPassword2(e.target.value)}
            />
          </div>
          <Button className="mb-5 w-full" onClick={resetPassword} loading={isLoading} color={ButtonColor.ORANGE} size={ButtonSize.LARGE}>
            Reset
          </Button>
          <Link className="backToLogin block text-center" to="/login">
            Back
          </Link>
        </div>
      </div>
      <div className="text-red-500">{errorMsg}</div>
    </div>
  );
}
